import { authService } from '@/platform/auth/services/authService';
import { createApiClient } from '@/shared/api/createApiClient';
import { config } from '@/shared/lib/config';

// In dev, use same-origin paths so Vite proxies /api → VITE_API_URL (avoids CORS).
const baseURL = import.meta.env.DEV ? '' : config.API_URL;

export const apiClient = createApiClient({
  baseURL,
  getToken: () => authService.getValidToken(),
  onAuthError: (error) => authService.handleApiAuthError(error),
  onAuthSuccess: () => authService.notifyRequestSucceeded(),
});
